export function currentPeriodProofView({ label, found, proof = null }) {
  const hasRow = found === true && Boolean(label);
  const range = proof?.sourceYMRange;
  const currentYM = proof?.currentYM;
  const rangeText = range?.start && range?.end ? `${range.start}->${range.end}` : null;
  const detail = hasRow && currentYM
    ? [currentYM, rangeText].filter(Boolean).join(' in ')
    : null;
  return {
    label: hasRow ? label : 'not in horizon',
    detail,
    posture: hasRow ? 'row-backed' : 'absent',
    chipKind: hasRow ? 'computed' : 'missing',
    tooltip: hasRow
      ? `Current period ${detail ?? label} is present in the rendered horizon rows; this is a runtime placement proof, not Ledger contract proof.`
      : 'Current period is not backed by the rendered horizon rows.',
  };
}
